import { GET_USER_PROFILE_TYPE } from "@/components/graphql/profiles";
import { getUserProfileType, getUserProfileTypeVariables } from "@/components/graphql/types/getUserProfileType";
import { FetchUserTypePayload } from "@/redux/slice/auth/types/FetchUserTypePayload";

export default async function fetchUserTypeApi(fetchUserTypePayload: FetchUserTypePayload) {
  const { mobileNumber, apolloClient } = fetchUserTypePayload;

  return await apolloClient.query<getUserProfileType, getUserProfileTypeVariables>({
    query: GET_USER_PROFILE_TYPE,
    variables: {
      mobileNumber,
    },
    fetchPolicy: "no-cache",
  });
}
